// Abonnement mensuel de coaching.
//
// NOTE INTERNE (invisible pour les visiteurs) : chaque palier annonce son
// équivalent à la carte, calculé depuis content/pricing.js. Si la grille à la
// carte change, ces montants doivent être recalculés — un test le vérifie.

export const COTISATION = {
  eyebrow: "Cotisation",
  title: "Progresser demande de la régularité.",
  lead: "Une séance tous les deux mois ne construit rien. L'abonnement fixe un rythme, coûte moins cher que la même chose à la carte, et s'arrête quand vous voulez.",
  notice: "Les paiements récurrents ne sont pas encore activés. Cette grille décrit l'offre qui s'appliquera à leur ouverture.",
};

export const TIERS = [
  {
    key: "regulier",
    name: "Régulier",
    price: 99,
    unit: "par mois",
    text: "Deux rendez-vous par mois pour garder un cap sans y passer vos soirées.",
    sessions: "2 séances d'une heure",
    // Détail du calcul à la carte, vérifié par test.
    equivalent: [["1 h", 2]],
    features: [
      "2 séances d'une heure, module standard",
      "Supplément FPS compris",
      "Suivi écrit entre les séances",
      "Objectifs suivis d'un mois sur l'autre",
      "10 % de remise sur le Custom",
    ],
  },
  {
    key: "intensif",
    name: "Intensif",
    price: 189,
    unit: "par mois",
    highlight: true,
    text: "Un rendez-vous par semaine. Le rythme auquel on voit vraiment une courbe monter.",
    sessions: "4 séances d'une heure",
    equivalent: [["1 h", 4]],
    features: [
      "4 séances d'une heure, module standard",
      "Supplément FPS compris",
      "Analyse d'une partie entre chaque séance",
      "Réponse à vos questions sous 24 heures",
      "10 % de remise sur le Custom",
    ],
  },
  {
    key: "competition",
    name: "Compétition",
    price: 299,
    unit: "par mois",
    text: "Pour une échéance datée : un tournoi, une montée de division, une sélection.",
    sessions: "4 séances dont deux longues et personnalisées",
    equivalent: [["1 h", 2], ["1 h 30 personnalisée", 2], ["préparation compétition", 1]],
    features: [
      "2 séances d'une heure et 2 séances d'1 h 30 en module personnalisé",
      "Préparation à la compétition comprise : règlements, formats, schémas de travail",
      "Supplément FPS compris",
      "Disponibilité les jours de match",
      "10 % de remise sur le Custom",
    ],
  },
];

export const COMMON = [
  { title: "Report d'une séance", text: "Une séance non utilisée se reporte sur le mois suivant. Une seule à la fois : au-delà, c'est que le rythme choisi n'est pas le bon." },
  { title: "Sans engagement", text: "Résiliable à tout moment depuis votre espace, sans préavis ni frais. Le mois entamé reste dû, les suivants non." },
  { title: "Changement de palier", text: "Vous montez ou descendez d'un palier quand vous voulez. Le changement prend effet au mois suivant." },
  { title: "Remise Custom", text: "10 % sur toutes les prestations de personnalisation et de réparation, tant que la cotisation est active." },
];

export const COTISATION_FAQ = [
  { q: "L'abonnement est-il moins cher que les séances à la carte ?", a: "Oui, entre 12 et 21 % selon le palier. Chaque palier affiche son équivalent à la carte : vous pouvez vérifier le calcul vous-même." },
  { q: "Que se passe-t-il si je ne peux pas faire mes séances ?", a: "Une séance se reporte sur le mois suivant. Au-delà d'une, elle est perdue — et c'est le signe qu'il faut descendre d'un palier." },
  { q: "Puis-je arrêter quand je veux ?", a: "Oui, sans préavis ni frais. Le mois commencé reste dû, les suivants ne sont pas prélevés." },
  { q: "Le supplément FPS est-il facturé en plus ?", a: "Non. Il est compris dans tous les paliers, contrairement au tarif à la carte où il ajoute 20 € par séance." },
  { q: "Puis-je offrir un abonnement ?", a: "Pas encore. Écrivez-nous : nous le mettons en place manuellement en attendant l'ouverture des paiements." },
];
